import { makeStyles } from '@material-ui/core/styles';

export const useDetailInformationStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    fontWeight: 700,
    display: '-webkit-box',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
  subtitle: {
    fontSize: 14,
  },
  subtitleWeight: {
    fontWeight: 600,
  },
  container: {
    '& :not(:last-child)': {
      marginRight: 13,
    },
  },
}));

export const useDetailButtonContainerStyles = makeStyles(() => ({
  container: {
    '& > *': {
      marginBottom: 13,
    },
  },
  button: {
    width: '100%',
    fontWeight: 600,
  },
  link: {
    textDecoration: 'none',
  },
}));
